import { styled } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'

const FeedHeader = styled(Grid)(({ theme }) => ({
  borderBottom: '1px solid  #C7CCD1',
  marginTop: 32,
  marginBottom: 24,
  '& h5': {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
      fontWeight: 500
    }
  },
  '& p': {
    whiteSpace: 'nowrap'
  }
}))

export default FeedHeader
